module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"dialog_titulo":"Confirmación de borrado","preg_borrar":"¿Estás seguro de que quieres borrar el material <span class=\u0027font-weight-bold\u0027>{material}</span>?","borrar":"Borrar","cerrar":"Cerrar"}}')
  delete Component.options._Ctor
}
